export default "__VITE_ASSET__5887ee2f__"